// Copyright (c) 2020 Deere & Company

import {addFavorites} from './add-favorite';
import {deleteFavorite} from './delete-favorite';

export default {
    addFavorites,
    deleteFavorite
};



// WEBPACK FOOTER //
// ./src/shared/components/favorites/action-creators/index.js